export default class AjusteParcial {
    constructor() {
        this.id = null;
        this.dia = null;
        this.diaInicio = null;
        this.diaFinal = null;
        this.horaInicio = null;
        this.horaFinal = null;
        this.codigoEvento = null;     
    }
}